
import { EditorSettings } from "@/utils/reminder-layouts/editor-settings";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import AppEditorSettingsPreviewData from "./EditorSettingsPreviewData.vue";

export default FormLike.extend({
	data(){
		return {
			settings: new EditorSettings(),
			hasValidSaleId: true,
		};
	},
	props: {
		value: {
			type: Object as ()=>EditorSettings,
			required: true
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.settings = new EditorSettings(this.value.getJSON());
			}
		},
		hasValidSaleId: {
			immediate: true,
			handler(){
				this.validate();
			}
		}
	},
	methods: {
		extendValidate(){
			if (!this.hasValidSaleId) {
				this.isValid = false;
			}
		},
		submit(){
			if (!this.isValid) return;
			this.$emit("input", new EditorSettings(this.settings.getJSON()));
			this.close();
		},
		close(){
			this.$emit("close");
		}
	},
	i18nEx: {
		componentPrefix: "components.reminder-layout-editor"
	},
	components: {
		AppEditorSettingsPreviewData
	}
});
